import React from 'react'
import 'react-modern-drawer/dist/index.css'
import { useAppSelector } from 'hooks/redux'
import {
  DrawerMyAgent,
  DrawerStatement,
  DrawerOutOfTimeRange,
  DrawerSuccess,
  DrawerError,
  DrawerNotifications,
  DrawerFilterDate,
  DrawerHelp,
  DrawerGrains,
  DrawerNotificationsDetails
} from 'components'
import DrawerDownloadDebin from './DrawerDownloadDebin'
import DrawerDebinDetail from './DrawerDebinDetail'
import DrawerDebinOperationError from './DrawerDebinOperationError'
import { Drawers } from 'store/drawer/types'
import ConfirmNewSaleOrder from 'components/organisms/Drawers/ConfirmNewSaleOrder'
import SaleOrderDetails from 'components/organisms/Drawers/SaleOrderDetails'
import SaleOrderSuccess from 'components/organisms/Drawers/SaleOrderSuccess'
import SaleOrderError from 'components/organisms/Drawers/SaleOrderError'
import QuotaDetails from './QuotaDetails'
import QuotaCreateSuccess from './QuotaCreateSuccess'
import HowWorksQuotas from './HowWorksQuotas'
import ApplicationsDetails from './ApplicationsDetails'
import LiquidationsDetails from './LiquidationsDetails'
import DrawerRepresentedDetail from './DrawerRepresentedDetail'
import ReceiptDetail from './ReceiptDetail'
import EmailSentSuccess from './EmailSentSuccess'
import EmailSentError from './EmailSentError'
import DocumentsSentSuccess from './DocumentsSentSuccess'
import DocumentsSentError from './DocumentsSentError'
import AddHumanPersonSuccess from './AddHumanPersonSuccess'
import AddHumanPersonError from './AddHumanPersonError'
import DrawerInvestmentInfo from './DrawerInvestmentInfo'
import InvestmentDetail from './DrawerInvestmentDetail'
import DrawerDebinOperationSuccess from './DrawerDebinOperationSuccess'

const DrawerContainer = () => {
  const {
    showDrawerError,
    showDrawerMyAgent,
    showDrawerSuccess,
    showStatementDrawer,
    showDrawerNotification,
    showHelpDrawer,
    drawerGrains,
    showDrawerNotificationDetail,
    showDrawerInvestmentInfo
  } = useAppSelector(state => state.modal)

  const { actives } = useAppSelector(state => state.drawer)

  return (
    <>
      {actives.includes(Drawers.RECEIPT_DETAIL) && <ReceiptDetail />}
      {actives.includes(Drawers.CONFIRM_NEW_SALE_ORDER) && (
        <ConfirmNewSaleOrder />
      )}
      {actives.includes(Drawers.SALE_ORDER_DETAILS) && <SaleOrderDetails />}
      {actives.includes(Drawers.SALE_ORDER_SUCCESS) && <SaleOrderSuccess />}
      {actives.includes(Drawers.QUOTA_CREATE_SUCCESS) && <QuotaCreateSuccess />}
      {actives.includes(Drawers.SALE_ORDER_ERROR) && <SaleOrderError />}
      {actives.includes(Drawers.OUT_OF_TIME) && <DrawerOutOfTimeRange />}
      {actives.includes(Drawers.QUOTA_DETAILS) && <QuotaDetails />}
      {actives.includes(Drawers.HOW_WORKS_QUOTA) && <HowWorksQuotas />}
      {actives.includes(Drawers.APPLICATIONS_DETAILS) && (
        <ApplicationsDetails />
      )}
      {actives.includes(Drawers.LIQUIDATIONS_DETAILS) && (
        <LiquidationsDetails />
      )}
      {actives.includes(Drawers.FILTER_DATE) && <DrawerFilterDate />}
      {actives.includes(Drawers.DOWNLOAD_DEBIN) && <DrawerDownloadDebin />}
      {actives.includes(Drawers.DEBIN_DETAIL) && <DrawerDebinDetail />}
      {actives.includes(Drawers.DEBIN_OPERATION_SUCCESS) && <DrawerDebinOperationSuccess />}
      {actives.includes(Drawers.DEBIN_OPERATION_ERROR) && <DrawerDebinOperationError />}
      {actives.includes(Drawers.REPRESENTED_DETAIL) && (
        <DrawerRepresentedDetail />
      )}
      {actives.includes(Drawers.REPRESENTED_DETAIL) && (
        <DrawerRepresentedDetail />
      )}
      {actives.includes(Drawers.EMAIL_SENT_SUCCESS) && <EmailSentSuccess />}
      {actives.includes(Drawers.EMAIL_SENT_ERROR) && <EmailSentError />}
      {actives.includes(Drawers.ADD_HUMAN_PERSON_SUCCESS) && (
        <AddHumanPersonSuccess />
      )}
      {actives.includes(Drawers.ADD_HUMAN_PERSON_ERROR) && (
        <AddHumanPersonError />
      )}
      {actives.includes(Drawers.DOCUMENTS_SENT_SUCCESS) && (
        <DocumentsSentSuccess />
      )}
      {actives.includes(Drawers.DOCUMENTS_SENT_ERROR) && <DocumentsSentError />}
      {actives.includes(Drawers.INVESTMENT_DETAIL) && <InvestmentDetail />}

      {showDrawerMyAgent && <DrawerMyAgent />}
      {showDrawerSuccess && <DrawerSuccess />}
      {showDrawerError && <DrawerError />}
      {showStatementDrawer && <DrawerStatement />}
      {showDrawerNotification && <DrawerNotifications />}
      {showHelpDrawer.isOpen && <DrawerHelp />}
      {drawerGrains.showDrawerGrains && <DrawerGrains />}
      {showDrawerNotificationDetail && <DrawerNotificationsDetails />}
      {showDrawerInvestmentInfo && <DrawerInvestmentInfo />}
    </>
  )
}

export default DrawerContainer
